import { render, staticRenderFns } from "./templateOrdinary.vue?vue&type=template&id=022edf9e&scoped=true&"
import script from "./templateOrdinary.vue?vue&type=script&lang=ts&"
export * from "./templateOrdinary.vue?vue&type=script&lang=ts&"
import style0 from "./templateOrdinary.vue?vue&type=style&index=0&id=022edf9e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022edf9e",
  null
  
)

export default component.exports